import {h, VNode} from 'snabbdom';

import {buildIconHtml} from './markup';
import {SvgIconType} from './types';

type SvgIconElProps = {
  icon?: SvgIconType;
  className?: string;
  color?: string;
  height?: string;
  empty?: boolean;
  hasUnread?: boolean;
  'has-unread'?: boolean;
  elref?: string;
  slot?: string;
  style?: Record<string, string>;
  key?: string | number;
  onClick?: (event: MouseEvent) => void;
};

/**
 * Panel/snabbdom form of the icon. Emits a bare `<svg-icon>` vnode with the icon
 * markup as `innerHTML` — DOM-identical to the pre-migration web component, so all
 * tag-selector/layout CSS keeps matching — and shares `buildIconHtml` with
 * `SvgIconReact` so both forms render the same markup.
 *
 * @deprecated Prefer `SvgIconReact` in React code. `SvgIconEl` exists only for
 * Panel/snabbdom render contexts (e.g. items-menu renderers, ParamComponent templates).
 */
export const SvgIconEl = ({
  icon,
  className,
  color,
  height,
  empty,
  hasUnread,
  'has-unread': hasUnreadAttr,
  elref,
  slot,
  style,
  key,
  onClick,
}: SvgIconElProps): VNode => {
  const html = !icon || empty ? `` : buildIconHtml(icon, color, height, hasUnreadAttr ?? hasUnread) ?? ``;
  return h(`svg-icon`, {
    key,
    attrs: {
      ...(icon ? {icon} : {}),
      ...(className ? {class: className} : {}),
      ...(elref ? {elref} : {}),
      ...(slot ? {slot} : {}),
    },
    ...(onClick ? {on: {click: onClick}} : {}),
    style,
    props: {innerHTML: html},
  });
};
